import { CommentsDollarDimensions } from "@styled-icons/fa-solid/CommentsDollar";
import React from "react";

const HorizontalRuler = ({ data }) => {
  console.info("HorizontalRuler", data);
  return data ? (
    <section className="px-5 my-26">
      <div className="border-b border-teal max-w-screen-xl xxl:max-w-screen-3xl mx-auto lg:mt-24"></div>
    </section>
  ) : (
    ""
  );
};

export default HorizontalRuler;
